/// <reference types="datatables.net" />
import { Omit } from '@app/utils/omit';
import { ClaimModelAjax } from '@app/models/claim';
import { SearchFilterModel } from '@app/models/search/filter';

export interface SearchRequestModel extends DataTables.AjaxDataRequest {
    searchFilter: SearchFilterRequestModel
}

export interface SearchResponseModel extends DataTables.AjaxData {
    data: ClaimModelAjax[];
    claimsTotal: number;
}

export type SearchFilterRequestModel = SearchFilterModel;

export function serializeSearchFilterModel(searchFilter: SearchFilterModel): SearchFilterRequestModel {
	return $.extend(true, {}, searchFilter as any) as SearchFilterRequestModel;
}